import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__chevron-right",
  "use": "icon__chevron-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__chevron-right\"><path d=\"M17.352 11.952a.992.992 0 0 1-.315.725l-8.914 9.906a.994.994 0 1 1-1.361-1.45l8.141-9.181-8.141-9.181a.994.994 0 1 1 1.361-1.45l8.914 9.906c.201.188.315.45.315.725z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol